import PropTypes from 'prop-types';
import advertisersStrings from 'modules/advertisers/strings';

import { Wrapper, AddAdvertiserBtn } from './AdvertisersHeader.style';

const AdvertisersHeader = ({ handleAddAdvertiserBtnClick }) => (
  <Wrapper>
    <AddAdvertiserBtn as="button" onClick={handleAddAdvertiserBtnClick}>
      {advertisersStrings.advertisersHeader.addAdvertiserBtn}
    </AddAdvertiserBtn>
  </Wrapper>
);

AdvertisersHeader.propTypes = {
  handleAddAdvertiserBtnClick: PropTypes.func.isRequired,
};

export default AdvertisersHeader;
